// Supabase CRUD for management reports (table: "reports").
import { supabase } from "../supabase/client";

const QUARTER_NUM = { Q1: 1, Q2: 2, Q3: 3, Q4: 4 };

// A single number so newest-first ordering is one clause.
export const sortKeyFor = (year, quarter) =>
  Number(year) * 10 + (QUARTER_NUM[quarter] || 0);

// DB (snake_case) → app (camelCase)
const fromRow = (r) => ({
  id: r.id,
  year: r.year,
  quarter: r.quarter,
  date: r.date,
  pages: r.pages,
  title: r.title,
  authors: r.authors,
  abstract: r.abstract,
  imageUrl: r.image_url,
  pdfUrl: r.pdf_url,
  content: r.content,
});

const toRow = (d) => ({
  year: Number(d.year),
  quarter: d.quarter,
  date: d.date,
  pages: d.pages ?? null,
  title: d.title,
  authors: d.authors,
  abstract: d.abstract,
  image_url: d.imageUrl,
  pdf_url: d.pdfUrl,
  content: d.content ?? null,
  sort_key: sortKeyFor(d.year, d.quarter),
});

export async function getReports() {
  const { data, error } = await supabase
    .from("reports")
    .select("*")
    .order("sort_key", { ascending: false });
  if (error) throw error;
  return data.map(fromRow);
}

export async function getReportById(id) {
  const { data, error } = await supabase
    .from("reports")
    .select("*")
    .eq("id", id)
    .maybeSingle();
  if (error) throw error;
  return data ? fromRow(data) : null;
}

export async function addReport(data) {
  const { error } = await supabase.from("reports").insert(toRow(data));
  if (error) throw error;
}

export async function updateReport(id, data) {
  const { error } = await supabase.from("reports").update(toRow(data)).eq("id", id);
  if (error) throw error;
}

export async function deleteReport(id) {
  const { error } = await supabase.from("reports").delete().eq("id", id);
  if (error) throw error;
}
